import data from './data.json';

export const CONNECTION_GAMES = data;
